import { AlertTriangle } from 'lucide-react';
import { Card, CardContent } from './card';
import { copy } from '../../shared/i18n';

export function LoadingState({ label = copy.common.loading }: { label?: string }) {
  return (
    <Card>
      <CardContent>
        <div className="sr-only" role="status">{label}</div>
        <div className="grid gap-3" aria-hidden="true">
          <div className="h-4 w-32 animate-pulse rounded bg-[#dfe8d8]" />
          <div className="grid gap-2">
            <div className="h-9 animate-pulse rounded-md bg-[#eef3ea]" />
            <div className="h-9 animate-pulse rounded-md bg-[#eef3ea]" />
            <div className="h-9 w-2/3 animate-pulse rounded-md bg-[#eef3ea]" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function ErrorState({ message }: { message: string }) {
  return (
    <Card className="border-[#efc9c0] bg-[#fff5f2]">
      <CardContent className="flex items-center gap-2 text-sm text-[#a94f40]">
        <AlertTriangle className="h-4 w-4" aria-hidden="true" />
        {message}
      </CardContent>
    </Card>
  );
}

export function EmptyState({ title, body }: { title: string; body: string }) {
  return (
    <div className="rounded-lg border border-dashed border-[#cfd8c6] bg-white p-6 text-center">
      <p className="text-sm font-semibold text-[#334033]">{title}</p>
      <p className="mt-1 text-sm text-[#687461]">{body}</p>
    </div>
  );
}
